import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPaintBrush: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPaintBrush"><Path d="M19.5 13.5V2.5H11.5L10 4.5L8.5 2.5H4.5V13.5H10L9.65595 19.0049C9.57144 20.357 10.6453 21.5 12 21.5C13.3547 21.5 14.4286 20.357 14.3441 19.0049L14 13.5H19.5Z" stroke="currentColor"/><Path d="M4.5 10.5H19.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconPaintBrush;
